import { Table } from "antd";
import PropTypes from "prop-types";

export default function DataTable(props) {
  const {
    style,
    columns,
    dataSource,
    pagination,
    expandable,
    scroll,
    className,
    showHeader,
    striped,
    rowSelection,
    onRow,
    components,
    rowKey,
    loading,
  } = props;

  return (
    <Table
      rowClassName={(record, index) =>
        striped !== false && index % 2 === 0
          ? "table-row-dark"
          : "table-row-light"
      }
      showHeader={showHeader}
      className={`antd-custom-card-table ${className}`}
      style={style}
      rowKey={rowKey}
      columns={columns}
      dataSource={dataSource && [...dataSource]}
      pagination={pagination}
      scroll={scroll}
      expandable={expandable}
      rowSelection={rowSelection}
      onRow={onRow}
      components={components}
      loading={loading}
    />
  );
}
DataTable.propTypes = {
  style: PropTypes.object,
  columns: PropTypes.array.isRequired,
  dataSource: PropTypes.array.isRequired,
  pagination: PropTypes.object,
  scroll: PropTypes.object,
  className: PropTypes.string,
  expandable: PropTypes.bool,
  showHeader: PropTypes.bool,
  striped: PropTypes.bool,
  rowSelection: PropTypes.object,
  onRow: PropTypes.func,
  components: PropTypes.object,
  rowKey: PropTypes.any,
  loading: PropTypes.bool,
};
